<template>
  <div class="wrap">
    <h1 class="row">{{translate('packing-slip-from')}}</h1>
    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p class="uppercase">
              <span class="title">2. {{translate('seller')}}:</span>  <span>BEL-AIR EXPRESS</span>
            </p>
          </div>
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p>
              <span class="title">3. {{translate('reference')}} {{translate('number-symbol')}}:</span>  <span>{{rfq3.stockID}}</span>
            </p>
          </div>
        </td>
      </tr>
    </table>
    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p class="uppercase">
              <span class="title">4. {{translate('organisation')}}:</span>  <span>BEL-AIR EXPRESS</span>
            </p>
            <p class="uppercase">
              <span class="title">4A. {{translate('organization-address')}}:</span>
            </p>
            <p>
              5 rue Andre Danjon,
            </p>
            <p>
              Paris 75019 FRANCE.
            </p>
            <p>
              Tel: +33-1-48032609
            </p>
          </div>
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p>
              <span class="title">5A. {{translate('invoice-number')}} {{translate('number-symbol')}}:</span>  <span>TBA</span>
            </p>
            <p>
              <span class="title">5B. {{translate('company')}}:</span>  <span>{{rfq3.rfq.customerCompany.name}}</span>
            </p>
            <p>
              <span class="title">5C. {{translate('customer-order')}} {{translate('number-symbol')}}:</span>  <span>{{rfq3.rfq.po}}</span>
            </p>
          </div>
        </td>
      </tr>
    </table>
    <table class="row table-invoice-details">
      <tr class="table__header table__row" bgcolor="#F8F9FA" style="border-bottom: 2px solid #BCBBBE;">
        <th><div class="title">6.{{translate('item')}}</div></th>
        <th><div class="title">7.{{translate('description')}}</div></th>
        <th><div class="title">8.{{translate('manufacturer-part-number')}}</div></th>
        <th><div class="title">9.{{translate('lig')}}</div></th>
        <th><div class="title">10.{{translate('qty')}}</div></th>
        <th><div class="title">11.{{translate('serial/batch')}}</div></th>
        <th><div class="title text-right">12.{{translate('status/work')}}</div></th>
      </tr>
      <tr
        class="table__row"
        style="border-bottom: 1px solid #BCBBBE;"
      >
        <td align="center"><div>1</div></td>
        <td align="center"><div>{{rfq3.part.partDescription}}</div></td>
        <td align="center"><div>{{rfq3.part.partNumber}}</div></td>
        <td align="center"><div>TBD</div></td>
        <td align="center"><div>{{rfq3.qty}}</div></td>
        <td align="center"><div>{{rfq3.partSN}}</div></td>
        <td align="right"><div>{{rfq3.stock.condition.title}}</div></td>
      </tr>
    </table>

    <div class="row">
      <div class="box-content">
        <div class="row" v-html="content.html1"></div>
      </div>
    </div>
    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p class="uppercase">
              <span class="title">13B. {{translate('traceable-to')}}:</span>
              <span>{{rfq3.traceabilityCompany.name}}</span>
            </p>
          </div>
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p>
              <span class="title">13C. {{translate('certificated-by')}}:</span>
              <span>{{rfq3.tagInfoCompany.name}}</span>
            </p>
          </div>
        </td>
      </tr>
    </table>
    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <div class="box-content">
            <div class="row" v-html="content.html2"></div>
          </div>
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <div class="row" v-html="content.html3"></div>
          </div>
        </td>
      </tr>
    </table>

    <table class="row">
      <tr>
        <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p class="uppercase">
              <span class="title uppercase">16. {{translate('signature')}}:</span>
              <i>Francois Rouach</i>
            </p>
          </div>
        </td>
        <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
          <div class="box-content">
            <p>
              <span class="title uppercase">17. {{translate('name')}}:</span>
              <span>Francois Rouach</span>
            </p>
            <p>
              <span class="title uppercase">{{translate('date')}}:</span>
              <span>{{today | toDate}}</span>
            </p>
          </div>
        </td>
      </tr>
    </table>

    <div class="row" style="margin-top: 230px">
      <p class="uppercase">
        PLEASE FIND ENCLOSED LIST OF INSTRUCTIONS
      </p>
      <p class="uppercase">
        REQUIRED BLOCKS TO FILL IN
      </p>
      <p class="uppercase">
        2,4,5B,5C,7,8,9,10,11,12,13B,16,17,18
      </p>
      <p class="uppercase">
        PLEASE RETURN WITH SHIPMENT OR Email support@bel-airexpress.com
      </p>
    </div>
  </div>
</template>
<script>
import { toDate } from '@/utils/filters'

export default {
  name: 'PdfPackingSlip',
  props: {
    translate: {
      type: Function
    },
    rfq3: {
      type: Object
    },
    content: {
      type: Object
    }
  },
  computed: {
    today () {
      return new Date()
    }
  },
  filters: {
    toDate: toDate
  }
}
</script>
